import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CartUpdateService } from '../Services/cartUpdate.service';
import { CartItemsCookieService } from '../Services/cartItemsCookie.service';
import { SnotifyService } from 'ng-snotify';
import { Course } from '../Models/course.model';
import { CourseWithQuantity } from '../Models/courseWithQuantity.model';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {
  addedCourses: Course[];
  addedCoursesWithQuantity: CourseWithQuantity[] = [];
  registrationType: string;

  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private cartItemsCookieService: CartItemsCookieService,
    private snotifyService: SnotifyService
  ) { }

  ngOnInit() {

    
    document.querySelector('#componentTop').scrollIntoView({ behavior: 'smooth', block: 'center' });

    this._route.data.subscribe(
      ({courses}) => {

        this.registrationType = this.cartItemsCookieService.getRegistrationTypeFromCookie();

        if(courses){
          this.addedCourses = courses;
          this.addedCoursesWithQuantity = [];
  
          courses.forEach((course) => {
              var addedItemsArray = this.cartItemsCookieService.getItemIdsFromCartCookie();
              
              var quantityOfCourse = addedItemsArray.filter((id) => id == course.id).length;
  
              this.addedCoursesWithQuantity.push({'course': course, 'quantity': quantityOfCourse});
          });
        }
       
        console.log('added courses with quantity: ', this.addedCoursesWithQuantity);
      });
  }

  getCourseTotal(fee: number, studentFee: number, quantity: number){
    if(this.registrationType == 'standard'){
      return fee * quantity;
    }else{
      return studentFee * quantity;
    }  
  }

  getSubTotal(): number{
    var subtotal = 0;

    this.addedCoursesWithQuantity.forEach((cw) => {
      if(this.registrationType == 'standard'){
        subtotal += (cw.course.fee * cw.quantity);
      }else{
        subtotal += (cw.course.studentFee * cw.quantity);
      }   
    });
    return subtotal;
  }

}



// WEBPACK FOOTER //
// ./src/app/registration/registration.component.ts